"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
/**
 * @param firestore instancia de Firestore
 * @param uid uid del paciente
 * @param dependantUid uid del dependant, si no se escribe se considerará que es un user principal
 * @returns obtiene el paciente siempre y cuando estes logeado
 */
async function getPatient(firestore, uid, dependantUid) {
    let patient;
    const path = dependantUid ? `user/${uid}/dependants/${dependantUid}` : `user/${uid}`;
    try {
        const docRef = (0, firestore_1.doc)(firestore, path);
        patient = await (0, firestore_1.getDoc)(docRef);
    }
    catch (err) {
        throw new Error(`db error ${err}`);
    }
    if (patient.exists()) {
        return patient.data();
    }
    else {
        throw new Error("error: patient don't exist.");
    }
}
exports.default = getPatient;
